import { CustomGraphChartViewmodel } from "@custom-graph/presentation/components/custom-graph-chart/custom-graph-chart.viewmodel";
import { CustomGraphFilterViewmodel } from "@custom-graph/presentation/components/custom-graph-filter/custom-graph-filter.viewmodel";
import { CustomGraphWebPageViewmodel } from "@custom-graph/presentation/pages/custom-graph/custom-graph-web.viewmodel";
import { DiModuleBuilder } from "@iot-platform/core";
import { ContainerModule } from "inversify";

const webCustomGraphModule = new DiModuleBuilder();

webCustomGraphModule.registerSubModules(() => ({
    viewModels: new ContainerModule(({ bind }) => {
        bind(CustomGraphWebPageViewmodel).toSelf();
        bind(CustomGraphFilterViewmodel).toSelf();
        bind(CustomGraphChartViewmodel).toSelf();
    }),
}));

webCustomGraphModule.registerModule();

export { webCustomGraphModule };
